import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "font-semibold text-sm" }
const _hoisted_3 = { class: "text-sm" }



export default /*#__PURE__*/_defineComponent({
  __name: 'SwiperDivLabelAndValueDiv',
  props: {
    label: null,
    value: null
  },
  setup(__props: any) {

const props = __props as {
  label: string
  value: string
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(props.label) + ":", 1),
    _createElementVNode("label", _hoisted_3, "  " + _toDisplayString(props.value), 1)
  ]))
}
}

})